import { useChartColors } from './useChartColors';

/**
 * Hook to provide consistent legend styling for charts
 * Returns standardized legend props using theme-aware colors
 */
export const useChartLegend = () => {
  const chartColors = useChartColors();

  return {
    wrapperStyle: {
      color: chartColors.text,
      paddingTop: '10px',
    },
  };
};
